import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionStartPollingPayment } from '../../actions/features';
import { IStore } from '../../reducers';
import { StatusModal } from '../../components/Modal/Payment';

const SuccessfulPromocode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedIn = useSelector((state: IStore) => state.auth.loggedIn);

  useEffect(() => {
    if (loggedIn) {
      dispatch(actionStartPollingPayment());
    }
  }, [dispatch, loggedIn]);

  return (
    <div className='main_page'>
      <StatusModal
        title='Premium Code Activated'
        subtitle='Congratulations!'
        description='Your premium code has been successfully activated. Enjoy the premium features of our service.'
        icon='icon-check-circle'
        iconColor='var(--green-600)'
        buttonText='Take me to Kattana!'
        onSubmit={() => navigate('/')}
      />
    </div>
  );
};

export default SuccessfulPromocode;
